var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.402,
    height: 16.049,
    viewBox: "0 0 15.402 16.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_1_",
    "data-name": "edit (1)",
    transform: "translate(0.05 0.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11417",
    "data-name": "Group 11417",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11416",
    "data-name": "Group 11416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13657",
    "data-name": "Path 13657",
    d: "M26.407,12.76h.086l4.16-.905a.409.409,0,0,0,.216-.108L37.916,4.7a2.716,2.716,0,0,0,.8-1.94A2.8,2.8,0,0,0,37.916.8a2.715,2.715,0,0,0-1.94-.8,2.651,2.651,0,0,0-1.94.819L27.01,7.867a.388.388,0,0,0-.129.194l-.905,4.16a.474.474,0,0,0,.129.41A.431.431,0,0,0,26.407,12.76ZM35.976.863a1.875,1.875,0,0,1,1.875,1.875q0,.011,0,.022a1.81,1.81,0,0,1-.539,1.315L34.662,1.4A1.853,1.853,0,0,1,35.976.863ZM34.058,2.027l2.651,2.651L30.567,10.8,27.916,8.169Zm-6.487,7L29.7,11.165l-2.737.6Z",
    transform: "translate(-25.222 0)",
    fill: "#7d7d7d",
    stroke: "#7d7d7d",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13658",
    "data-name": "Path 13658",
    d: "M22.709,365.717H8.269a.431.431,0,0,0,0,.862h14.44a.431.431,0,0,0,0-.862Z",
    transform: "translate(-7.838 -350.63)",
    fill: "#7d7d7d",
    stroke: "#7d7d7d",
    strokeWidth: 0.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.98bebe4bd1cd038ec80a8afdf491ed16.svg";
export { ForwardRef as ReactComponent };